document.querySelectorAll('.agenda-session__details').forEach(function (details) {
  var content = details.querySelector('.agenda-session__content');
  if (details.open) details.classList.add('is-open');

  details.querySelector('summary').addEventListener('click', function (e) {
    e.preventDefault();

    if (details.open) {
      details.classList.remove('is-open');
      content.style.height = content.scrollHeight + 'px';
      content.style.display = 'block';
      content.style.overflow = 'hidden';
      content.offsetHeight;
      content.style.transition = 'height var(--animation-primary)';
      content.style.height = '0';
      content.addEventListener('transitionend', function handler() {
        details.removeAttribute('open');
        content.style.cssText = '';
        content.removeEventListener('transitionend', handler);
      });
    } else {
      details.setAttribute('open', '');
      details.classList.add('is-open');
      var targetHeight = content.scrollHeight;
      content.style.height = '0';
      content.style.overflow = 'hidden';
      content.offsetHeight;
      content.style.transition = 'height var(--animation-primary)';
      content.style.height = targetHeight + 'px';
      content.addEventListener('transitionend', function handler() {
        content.style.cssText = '';
        content.removeEventListener('transitionend', handler);
      });
    }
  });
});

document.querySelectorAll('.programme-evenement').forEach(function (container) {
  container.querySelectorAll('.programme-evenement__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var targetId = tab.dataset.tab;

      container.querySelectorAll('.programme-evenement__tab').forEach(function (otherTab) {
        otherTab.classList.remove('is-active');
        otherTab.setAttribute('aria-selected', 'false');
      });

      container.querySelectorAll('.programme-evenement__panel').forEach(function (otherPanel) {
        otherPanel.classList.remove('is-active');
        otherPanel.setAttribute('hidden', '');
      });

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      var panel = document.getElementById(targetId);
      if (panel) {
        panel.classList.add('is-active');
        panel.removeAttribute('hidden');
      }
    });
  });
});
